<div class="row mb-2">
    <div class="col">
        <div widget class="card border-0 box-shadow">

            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row mt-2">
                    <div class="col-6">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateServicemodal" (click)="clearService()"    *ngIf="fp.servicecreate">Add
                            Service </button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn btn-sm text-right" (click)="Refresh()">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
 <!-- ejs-grid -->
                <div class="row mt-3" style="min-height: 500px;">
                    <div class="col">
                        <ejs-grid #gridService [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
                        [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                        (dataStateChange)='dataChangeService($event)' [showColumnChooser]='true'
                        (actionBegin)="onActionService($event)" [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal"
                                        data-bs-target="#CreateServicemodal" (click)="getDetails(data)"
                                        *ngIf="fp.serviceupdate"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" data-bs-toggle="modal"
                                        data-bs-target="#deleteServiceModal" (click)="getDetails(data)"
                                        *ngIf="fp.servicedelete"><i
                                            class="fa fa-trash"  ></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="serviceGroupName" headerText="Service Group Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="description" headerText="Description " type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="serviceName" headerText="Service Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="serviceCode" headerText="Service Code" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>

                            <e-column minWidth=100 field="modifier1" headerText="Modifier 1" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="modifier2" headerText="Modifier 2 " type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="modifier3" headerText="Modifier 3" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>

                            <e-column minWidth=100 field="modifier4" headerText="Modifier 4 " type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="ratio" headerText="Ratio" type="number">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox mask="0000000000" placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="serviceLocationCode" headerText="Service LocationCode" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showServiceColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- For Create or Update Modal -->
<span id="openServiceModal" data-bs-toggle="modal" data-bs-target="#CreateServicemodal"></span>
<div class="modal fade" id="CreateServicemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="saveServiceInfo.id == '00000000-0000-0000-0000-000000000000'">
                        Create Service</span>
                    <span *ngIf="saveServiceInfo.id !='00000000-0000-0000-0000-000000000000'">Update Service</span>
                </h5>
                <button type=" button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" (click)="clearService()"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5">
                        <label>Code<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.serviceCode" />
                    </div>

                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Service Name<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.serviceName" />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Service Group<sup class="super-script">*</sup>
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select  class="width25" [searchable]="true" [clearable]="true"
                            bindLabel="Value" bindValue="Key"
                            [items]="ServiceGroupList"
                             [(ngModel)]="saveServiceInfo.serviceGroupId" (ngModelChange)="ServiceTypeRestriction(saveServiceInfo.serviceGroupId)">
                        </ng-select>
                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Modifier 1
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.modifier1" />
                    </div>
                </div>

                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Modifier 2
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.modifier2" />
                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Modifier 3
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.modifier3" />
                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Modifier 4
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.modifier4" />
                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Ratio
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="number" class="form-control" [(ngModel)]="saveServiceInfo.ratio" />
                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Service Location Code
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.serviceLocationCode" />                    </div>
                </div>
                <div class="row  mt-1">
                    <div class="col-lg-5">
                        <label>Description
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control" [(ngModel)]="saveServiceInfo.description" />                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>ExcludeFromBudget
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="checkbox" class="mt-2"  [(ngModel)]="saveServiceInfo.excludeFromBudget" />
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Is Transportation
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <input type="checkbox" class="mt-2"  [(ngModel)]="saveServiceInfo.isTransportation" />
                    </div>
                </div>
                 <div class="row mt-1">
                    <div class="col-lg-5">
                        <label>Service Type
                        </label>
                    </div>
                    <div class="col-lg-7">
                        <ng-select  class="width25" [searchable]="true" [clearable]="true"
                            bindLabel="lovName" bindValue="id"
                            [items]="ServiceTypeList"
                            [(ngModel)]="saveServiceInfo.serviceTypeLid">
                        </ng-select>
                    </div>
                </div> 
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateServiceGroup();"
                [disabled]="isSaveorUpdateBoolean || saveServiceInfo.serviceCode==null || saveServiceInfo.serviceCode==undefined||
                saveServiceInfo.serviceCode=='' ||
                saveServiceInfo.serviceName==null || saveServiceInfo.serviceName==undefined||
                saveServiceInfo.serviceName==''||


                saveServiceInfo.serviceGroupId==null || saveServiceInfo.serviceGroupId==undefined||
                saveServiceInfo.serviceGroupId==''
                "><span
                        *ngIf="saveServiceInfo.id == '00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span> <span *ngIf="saveServiceInfo.id != '00000000-0000-0000-0000-000000000000'">Update &
                        Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearService()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeServiceModal" data-bs-target="#deleteServiceModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteServiceModal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteService()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearService()"
                    data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
